<template>
    <form class="col-md-12 mx-auto" @submit.prevent="onSave">
        <div class="card border-primary mb-3" id="participantEditCard">
            <h5 class="card-header text-primary">
                <i class="fas fa-user-edit mr-2"></i>
                {{fullName}}
            </h5>
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="participantEditCardRequiredFields.firstName ? 'required' : ''"
                               :for="'firstName' + _uid"
                        >{{$t('person.firstName')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.firstName"
                            v-validate="participantEditCardRequiredFields.firstName ? 'required' : ''"
                            :data-vv-as="$t('person.firstName')"
                            :name="'firstName' + _uid"
                            :id="'firstName' + _uid"
                        />
                        <span class="text-danger" v-if="errors.has('firstName' + _uid)">{{ errors.first('firstName' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="participantEditCardRequiredFields.middleName ? 'required' : ''"
                               :for="'surName' + _uid">{{ $t('person.middleName') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.middleName"
                            v-validate="participantEditCardRequiredFields.middleName ? 'required' : ''"
                            :data-vv-as="$t('person.middleName')"
                            :id="'middleName' + _uid"
                            :name="'middleName' + _uid" />
                        <span class="text-danger" v-if="errors.has('middleName' + _uid)">{{ errors.first('middleName' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="participantEditCardRequiredFields.lastName ? 'required' : ''"
                               :for="'lastName' + _uid">{{ $t('person.lastName')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.lastName"
                            v-validate="participantEditCardRequiredFields.lastName ? 'required' : ''"
                            :data-vv-as="$t('person.lastName')"
                            :name="'lastName' + _uid"
                            :id="'lastName' + _uid"
                        />
                        <span class="text-danger" v-if="errors.has('lastName' + _uid)">{{ errors.first('lastName' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :for="'firstNameEn' + _uid">{{ $t('person.firstNameEn') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.firstNameEn"
                            :id="'firstNameEn' + _uid"
                            :name="'firstNameEn' + _uid" />
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :for="'middleNameEn' + _uid">{{ $t('person.middleNameEn') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.middleNameEn"
                            :id="'middleNameEn' + _uid"
                            :name="'middleNameEn' + _uid" />
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :for="'lastNameEn' + _uid">{{ $t('person.lastNameEn') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.lastNameEn"
                            :id="'lastNameEn' + _uid"
                            :name="'lastNameEn' + _uid" />
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-8">
                        <label class="font-weight-bold" :class="participantEditCardRequiredFields.identificationNumber ? 'required' : ''">{{ $t('person.identification') }}</label>
                        <person-identification
                            :identification="model.person.personIdentification"
                            :required="participantEditCardRequiredFields.identificationNumber"
                            :disabled="false"
                            :validateUniqueIdNumber="validateUniqueIdNumber"
                            :validateEgn="validateEgn"
                            @getGenderTypeId="model.person.genderTypeId = $event"
                        ></person-identification>
                    </div>

                    <div class="form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold">{{ $t('person.gender') }}</label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="genderTypeSort"
                            v-model="model.person.genderTypeId"
                            :required="participantEditCardRequiredFields.gender"
                            :fieldName="$t('person.gender')"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :disabled="false"
                        ></dropdown>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold"
                               :class="participantEditCardRequiredFields.idCardNumber ? 'required' : ''"
                               :for="'idCardNumber' + _uid">{{ $t('person.idCardNumber') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.idCardNumber"
                            v-validate="participantEditCardRequiredFields.idCardNumber ? 'required' : ''"
                            :data-vv-as="$t('person.idCardNumber')"
                            :name="'idCardNumber' + _uid"
                            :id="'idCardNumber' + _uid" />
                        <span class="text-danger" v-if="errors.has('idCardNumber' + _uid)">{{ errors.first('idCardNumber' + _uid) }}</span>
                    </div>

                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold"
                               :class="participantEditCardRequiredFields.idCardDateOfIssue ? 'required' : ''"
                               :for="'idCardDateOfIssue' + _uid">{{ $t('person.idCardDateOfIssue') }}</label>
                        <date-only-picker
                            v-model="model.person.idCardDateOfIssue"
                            :enableTimePicker="false"
                            :required="participantEditCardRequiredFields.idCardDateOfIssue"
                            :readonly="false"
                            :showTime="false"
                            :id="'idCardDateOfIssue' + _uid"
                            :name="'idCardDateOfIssue' + _uid"
                        ></date-only-picker>
                    </div>

                    <div class="form-group form-group col-sm-12 col-md-4">
                        <label class="font-weight-bold"
                               :class="participantEditCardRequiredFields.idCardIssuedBy ? 'required' : ''"
                               :for="'idCardIssuedBy' + _uid">{{ $t('person.idCardIssuedBy') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.idCardIssuedBy"
                            v-validate="participantEditCardRequiredFields.idCardIssuedBy ? 'required' : ''"
                            :data-vv-as="$t('person.idCardIssuedBy')"
                            :name="'idCardIssuedBy' + _uid"
                            :id="'idCardIssuedBy' + _uid" />
                        <span class="text-danger" v-if="errors.has('idCardIssuedBy' + _uid)">{{ errors.first('idCardIssuedBy' + _uid) }}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold required"
                               :class="participantEditCardRequiredFields.email ? 'required' : ''"
                               :for="'email' + _uid">{{ $t('email') }}</label>
                        <input
                            type="email"
                            class="form-control"
                            :readonly="false"
                            v-model="model.person.email"
                            v-validate="participantEditCardRequiredFields.email ? 'required|email' : 'email'"
                            :data-vv-as="$t('email')"
                            :name="'email' + _uid"
                            :id="'email' + _uid" />
                        <span class="text-danger" v-if="errors.has('email' + _uid)">{{ errors.first('email' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="participantEditCardRequiredFields.phone ? 'required' : ''"
                               :for="'phone' + _uid"
                               :readonly="false">{{ $t('person.phone') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.phone"
                            v-validate="participantEditCardRequiredFields.phone ? 'required' : ''"
                            :data-vv-as="$t('person.phone')"
                            :id="'phone' + _uid"
                            :name="'phone' + _uid"
                            :readonly="false" />
                        <span class="text-danger" v-if="errors.has('phone' + _uid)">{{ errors.first('phone' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold"
                               :class="participantEditCardRequiredFields.mobilePhone ? 'required' : ''"
                               :for="'mobilePhone' + _uid">{{ $t('person.mobilePhone') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.mobilePhone"
                            v-validate="participantEditCardRequiredFields.mobilePhone ? 'required' : ''"
                            :data-vv-as="$t('person.mobilePhone')"
                            :id="'mobilePhone' + _uid"
                            :name="'mobilePhone' + _uid"
                            :readonly="false" />
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold">{{ $t('person.description') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.description"
                            :id="'description' + _uid"
                            :readonly="false"
                        />
                    </div>
                </div>

                <InstitutionSelector v-model="model.person" :is-required="participantEditCardRequiredFields.institution"></InstitutionSelector>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold required"
                            :class="participantEditCardRequiredFields.positionStatistic ? 'required' : ''"
                        >{{ $t('person.positionStatistic') }}</label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="positionStatisticSort"
                            :required="participantEditCardRequiredFields.positionStatistic"
                            v-model="model.person.positionStatisticId"
                            :fieldName="$t('person.positionStatistic')"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :disabled="false"
                        ></dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :class="participantEditCardRequiredFields.position ? 'required' : ''">{{ $t('person.position') }}</label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="positionSort"
                            :required="participantEditCardRequiredFields.position"
                            v-model="model.person.position"
                            :fieldName="$t('person.position')"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :disabled="false"
                        ></dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :for="'positionStr' + _uid"
                        >{{ $t('person.positionFullName') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.person.positionStr"
                            :id="'positionStr' + _uid"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('person.salutation') }}</label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="salutationSort"
                            v-model="model.person.salutationId"
                            :fieldName="$t('person.salutation')"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :disabled="false"
                        ></dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold">{{ $t('person.titleDegree') }}</label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="titleDegreeSort"
                            v-model="model.person.titleDegreeId"
                            :fieldName="$t('person.titleDegree')"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :disabled="false"
                        ></dropdown>
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label class="font-weight-bold" :class="participantEditCardRequiredFields.education ? 'required' : ''">{{ $t('person.educationDegree') }}</label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="educationDegreeSort"
                            :required="participantEditCardRequiredFields.education"
                            v-model="model.person.educationDegreeId"
                            :fieldName="$t('person.educationDegree')"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :disabled="false"
                        ></dropdown>
                    </div>
                </div>

                <BankAccountEditor
                    :bankAccount="model.bankAccount"
                    :required="false"
                    :showDescription="false"
                    :readonly="false"
                ></BankAccountEditor>

                <hr />

                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold required"
                            :for="'participationType' + _uid"
                        >{{$t("registers.events.participants.gridHeaders.participationType")}}</label>
                        <dynamic-dropdown
                            :apiUrl="`/api/participationType/getDropdownModels`"
                            v-model="model.participationTypeId"
                            :id="'participationType' + _uid"
                            :name="'participationType' + _uid"
                            :required="true"
                            :fieldName="$t('registers.events.participants.gridHeaders.participationType')"
                            :filter="'contains'"
                            :height="500"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            aria-describedby="participationTypeHelp"
                        ></dynamic-dropdown>
                        <small
                            id="participationTypeHelp"
                            class="form-text text-muted"
                        >{{$t("registers.events.participants.help.participationType")}}</small>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold"
                            :for="'ralationType' + _uid"
                        >{{$t("registers.events.participants.gridHeaders.relationType")}}</label>
                        <dynamic-dropdown
                            ref="participationRelationType"
                            :apiUrl="`/api/participationRelationType/getDropdownModels`"
                            v-model="model.relationTypeId"
                            :id="'ralationType' + _uid"
                            :name="'ralationType' + _uid"
                            :required="false"
                            :fieldName="$t('registers.events.participants.gridHeaders.relationType')"
                            :filter="'contains'"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :filterObject="participationRelationTypeFilter"
                            :applyFilterObject="true"
                            :disabled="disabledParticipationRelationType"
                            aria-describedby="relationTypeHelp"
                        ></dynamic-dropdown>
                        <small
                            id="relationTypeHelp"
                            class="form-text text-muted"
                        >{{$t("registers.events.participants.help.relationType")}}</small>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold"
                            :for="'reasonForAdmission' + _uid"
                        >{{$t("registers.events.participants.gridHeaders.reasonForAdmission")}}</label>
                        <dynamic-dropdown
                            ref="reasonForAdmission"
                            :apiUrl="`/api/reasonForAdmission/getDropdownModels`"
                            v-model="model.reasonForAdmissionId"
                            :id="'reasonForAdmission' + _uid"
                            :name="'reasonForAdmission' + _uid"
                            :required="false"
                            :fieldName="$t('registers.events.participants.gridHeaders.reasonForAdmission')"
                            :filter="'contains'"
                            :height="500"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :filterObject="reasonForAdmissionFilter"
                            :applyFilterObject="true"
                            :disabled="disabledReasonForAdmission"
                            aria-describedby="reasonForAdmissionHelp"
                        ></dynamic-dropdown>
                        <small
                            id="reasonForAdmissionHelp"
                            class="form-text text-muted"
                        >{{$t("registers.events.participants.help.reasonForAdmission")}}</small>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold"
                            :for="'participationStatus' + _uid"
                        >{{$t("registers.events.participants.gridHeaders.status")}}</label>
                        <dynamic-dropdown
                            :apiUrl="`/api/participant/participationStatusesDropdownSource`"
                            v-model="model.statusId"
                            :id="'participationStatus' + _uid"
                            :name="'participationStatus' + _uid"
                            :required="false"
                            :fieldName="$t('registers.events.participants.gridHeaders.status')"
                            :filter="'contains'"
                            :height="500"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            aria-describedby="participationStatusHelp"
                        ></dynamic-dropdown>
                        <small
                            id="participationStatusHelp"
                            class="form-text text-muted"
                        >{{$t("registers.events.participants.help.participationStatus")}}</small>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label
                            class="font-weight-bold"
                            :for="'note' + _uid"
                        >{{ $t('registers.events.participants.gridHeaders.note') }}</label>
                        <textarea
                            class="form-control"
                            rows="5"
                            v-model="model.note"
                            :name="'note' + _uid"
                            :id="'note' + _uid"
                        ></textarea>
                    </div>
                </div>

                <hr />

                <div class="row mt-md-2 mt-sm-1">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :for="'firstName' + _uid"
                        >{{$t('reportData.participants.deployed')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.deployed"
                            :name="'deployed' + _uid"
                            :id="'deployed' + _uid"
                        />
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :for="'cityOfCurrentAddress' + _uid"
                        >{{ $t('reportData.participants.cityOfCurrentAddress') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.cityOfCurrentAddress"
                            :name="'cityOfCurrentAddress' + _uid"
                            :id="'cityOfCurrentAddress' + _uid"
                        />
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :for="'currentSettlement' + _uid"
                        >{{$t("reportData.participants.currentSettlement")}}</label>
                        <city-dropdown-search v-model="model.currentSettlementId"></city-dropdown-search>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :for="'accommodationRequest' + _uid"
                        >{{$t('reportData.participants.accommodationRequest')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.accommodationRequest"
                            :name="'accommodationRequest' + _uid"
                            :id="'accommodationRequest' + _uid"
                        />
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :for="'datesForNights' + _uid"
                        >{{$t('reportData.participants.datesForNights')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.datesForNights"
                            :name="'datesForNights' + _uid"
                            :id="'datesForNights' + _uid"
                        />
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :for="'roomType' + _uid"
                        >{{$t('reportData.participants.roomType')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.roomType"
                            :name="'roomType' + _uid"
                            :id="'roomType' + _uid"
                        />
                    </div>

                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.vegetarianMenu"
                            :name="'vegetarianMenu' + _uid"
                            :id="'vegetarianMenu' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.vegetarianMenu') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.travelers"
                            :name="'travelers' + _uid"
                            :id="'travelers' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.travelers') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.consentToBeProcessed"
                            :name="'consentToBeProcessed' + _uid"
                            :id="'consentToBeProcessed' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.consentToBeProcessed') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <label
                            class="font-weight-bold"
                            :for="'employment' + _uid"
                        >{{$t("reportData.participants.employment")}}</label>
                        <dynamic-dropdown
                            :apiUrl="`/api/nomenclatures/getDropdownModels/employment`"
                            v-model="model.employmentId"
                            :id="'employment' + _uid"
                            :name="'employment' + _uid"
                            :required="false"
                            :fieldName="$t('reportData.participants.employment')"
                            :filter="'contains'"
                            :bindPopup="true"
                            :popupContainerId="'#participantEditCard'"
                            :height="500"
                        ></dynamic-dropdown>
                    </div>
                </div>

                <hr />

                <div class="row mt-md-2 mt-sm-1">
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.isMigrant"
                            :name="'isMigrant' + _uid"
                            :id="'isMigrant' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.isMigrant') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.isForeigner"
                            :name="'isForeigner' + _uid"
                            :id="'isForeigner' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.isForeigner') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.isMemberOfAMinority"
                            :name="'isMemberOfAMinority' + _uid"
                            :id="'isMemberOfAMinority' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.isMemberOfAMinority') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.isOfGypsyOrigin"
                            :name="'isOfGypsyOrigin' + _uid"
                            :id="'isOfGypsyOrigin' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.isOfGypsyOrigin') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.withDisabilities"
                            :name="'withDisabilities' + _uid"
                            :id="'withDisabilities' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.withDisabilities') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.isHomeless"
                            :name="'isHomeless' + _uid"
                            :id="'isHomeless' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.isHomeless') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.isDisadvantaged"
                            :name="'isDisadvantaged' + _uid"
                            :id="'isDisadvantaged' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.isDisadvantaged') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.isFromUnemployedHousehold"
                            :name="'isFromUnemployedHousehold' + _uid"
                            :id="'isFromUnemployedHousehold' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.isFromUnemployedHousehold') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.withDependentChildren"
                            :name="'withDependentChildren' + _uid"
                            :id="'withDependentChildren' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.withDependentChildren') }}</vs-checkbox>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 col-lg-4">
                        <vs-checkbox
                            v-model="model.fromOneMemberHousehold"
                            :name="'fromOneMemberHousehold' + _uid"
                            :id="'fromOneMemberHousehold' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('reportData.participants.fromOneMemberHousehold') }}</vs-checkbox>
                    </div>
                </div>

                <hr />

                <div  v-if="model.attachedFiles && model.attachedFiles.length > 0">
                    <div class="k-display-flex" v-for="(file, index) in model.attachedFiles" :key="'file'+file.id">
                        <div class="col-12">
                            <file-download v-if="file.id"
                                :file="file"
                                :showDescription="true"
                                :type="file.docTypeCode">
                            </file-download>
                        </div>

                        <i
                            class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                            @click="removeFile(file,index)"
                        ></i>
                    </div>
                </div>

                <div class="form-group col-12">
                    <file-upload
                        ref="fileUpload"
                        :key="'fileUpload' + model.id"
                        :model="files"
                        @fileRemoved="fileRemoved"
                    ></file-upload>
                </div>

                <hr />

                <div
                    class="form-group col-10 row pl-2"
                    aria-describedby="updatePersonFromParticipantHelpBlock"
                >
                    <i
                        class="fas fa-exclamation-triangle fa-2x text-warning ml-2 mr-2"
                        v-if="model.updatePersonFromParticipant"
                    ></i>
                    <vs-checkbox
                        v-model="model.updatePersonFromParticipant"
                        :name="'updatePersonFromParticipant' + _uid"
                        :id="'updatePersonFromParticipant' + _uid"
                        style="justify-content: flex-start !important"
                    >{{ $t('registers.participants.updatePersonFromParticipant') }}</vs-checkbox>
                </div>
                <small
                    id="updatePersonFromParticipantHelpBlock"
                    class="form-text text-muted"
                >{{ $t('registers.participants.updatePersonFromParticipantDescription') }}</small>

                <div class="text-right mt-3">
                    <div class="btn-group" role="group" aria-label="Person edit buttons">
                        <button type="button" class="btn btn-success" :disabled="saving" @click.stop="onSave">
                            <i v-if="saving" class="fas fa-spinner fa-spin"></i>
                            <i v-else class="fas fa-save"></i>
                            {{ $t('buttons.save.btnText')}}
                        </button>
                        <button type="button" class="btn btn-danger" :disabled="saving" @click.stop="onCancel">
                            <i class="fas fa-ban"></i>
                            {{ $t('buttons.cancel')}}
                        </button>
                    </div>
                </div>
            </div>

            <div
                class="card-footer text-muted"
                v-if="model.person.relatedUsername"
            >{{ $t('person.relatedToUser') + '"' + model.relatedUsername + '"' }}</div>
        </div>
    </form>
</template>

<script>
import { Participant } from "@/models/models";
import PersonIdentificationComponent from "@/components/person/PersonIdentification";
import Dropdown from "@/components/dropdown/NomenclatureDropdown";
import { NomenclatureParentBySort } from "@/models/enums";
import DynamicDropdown from "@/components/dropdown/DynamicDropdown";
import FileUpload from "@/components/common/FileUploadSaveAsTemp";
import FileDownload from "@/components/common/FileDownload";
import participantService from "@/services/participant.service";
import DateOnlyPicker from "@/components/datepicker/DateOnlyPicker";
import InstitutionSelector from "@/components/common/InstitutionSelector";
import CityDropdownSearch from "@/components/dropdown/CityDropdownSearch";
import BankAccountEditor from "@/components/bankAccount/BankAccountEditor";
import { mapGetters } from "vuex";

export default {
    inject: ["$validator"],
    props: {
        value: {
            type: Participant,
            required: false,
        },
        create: {
            type: Boolean,
            default: false,
        },
        validateUniqueIdNumber: {
            type: Boolean,
            default: false,
        },
        validateEgn: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Dropdown,
        "person-identification": PersonIdentificationComponent,
        DynamicDropdown,
        FileUpload,
        FileDownload,
        DateOnlyPicker,
        InstitutionSelector,
        CityDropdownSearch,
        BankAccountEditor,
    },
    data() {
        return {
            model: this.value,
            files: [],
            genderTypeSort: NomenclatureParentBySort.GenderType,
            positionStatisticSort: NomenclatureParentBySort.PositionStatistic,
            positionSort: NomenclatureParentBySort.Position,
            salutationSort: NomenclatureParentBySort.Salutation,
            titleDegreeSort: NomenclatureParentBySort.TitleDegree,
            educationDegreeSort: NomenclatureParentBySort.EducationDegree,
            saving: false
        };
    },
    methods: {
        removeFile(file, index) {
            this.model.attachedFiles.splice(index, 1);
            this.model.deletedAttachedFilesId.push(file.id);
        },
        onCancel(e) {
            this.$emit("cancel", e);
        },
        onSave() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    kendo
                        .confirm(
                            `${
                                this.create
                                    ? this.$t("person.confirmations.create")
                                    : this.$t("person.confirmations.edit")
                            } '${this.fullName}'?`
                        )
                        .then(
                            function () {
                                this.doSave();
                            }.bind(this)
                        );
                }
            });
        },
        doSave() {
            if (Array.isArray(this.files) && this.files.length > 0) {
                let tempFileIds = [];
                this.files.forEach((file) => {
                    tempFileIds.push(file.tempId);
                });

                this.model.tempFileIds = tempFileIds;
            }

            if (this.create && this.isNew) {
                // Create
                this.createParticipant();
            } else {
                // Update
                this.updateParticipant();
            }
        },
        createParticipant() {
            this.saving = true;

            participantService
                .create(this.model)
                .then((response) => {
                    let resultModel = response.data.model;

                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.responseStatusCode(response)
                        ),
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });

                    this.$emit("save", resultModel);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => { this.saving = false; });
        },
        updateParticipant() {
            this.saving = true;

            participantService
                .update(this.model)
                .then((response) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.responseStatusCode(response)
                        ),
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });

                    this.$emit("save", this.model);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => { this.saving = false; });
        },
        fileRemoved(fileToRemove) {},
        clearFiles() {
            this.files = [];
            let fu = this.$refs.fileUpload;
            if (fu) {
                fu.clearFiles();
            }
        },
    },
    computed: {
        ...mapGetters(["isEnVersion", "authToken", 'participantEditCardRequiredFields']),
        token: function () {
            return this.authToken;
        },
        fullName() {
            let name = this.model.person.firstName;
            if (this.model.person.middleName) {
                name += ` ${this.model.person.middleName}`;
            }

            if (this.model.person.lastName) {
                name += ` ${this.model.person.lastName}`;
            }

            return name;
        },
        isNew() {
            let id = Number(this.model.id);
            return isNaN(id) || id <= 0;
        },
        disabledParticipationRelationType() {
            return !this.model.participationTypeId;
        },
        disabledReasonForAdmission() {
            return !this.model.participationTypeId;
        },
        participationRelationTypeFilter() {
            return { participationTypeId: this.model.participationTypeId };
        },
        reasonForAdmissionFilter() {
            return this.participationRelationTypeFilter;
        },
    },
    watch: {
        value: function (val) {
            if (val) {
                this.clearFiles();
                this.model = new Participant(this.value);
            }
        },
    },
};
</script>

<style scoped>
input[readonly] {
    background-color: whitesmoke;
}

textarea[readonly] {
    background-color: whitesmoke;
}
</style>
